import Reflux from "reflux";
import _ from "lodash";
import Immutable from "immutable";
import AppConstants from "../constants/AppConstants";
import SiteDesignStore from "./SiteDesignStore";
import UIActions from "../actions/UIActions";
import DocumentStore from "../document/DocumentStore";
import { COMMANDS } from "../document/commands";
import LayoutChooserActions from "../actions/LayoutChooserActions";
import { convertParallaxForMobile } from "../utils/DataUtils";

import DesktopToMobileTransformer from "../transform/DesktopToMobileTransformer";

var initialState = {
  title: "Mobile Layout Chooser",
  block: null,
  preview: {
    blocks: null,
    theme: null,
  },
  settings: {
    layout: "auto",
    copyElementProps: true,
    copyBlockProps: true,
  },
};

var LayoutChooserStore = Reflux.createStore({
  storeName: 'LayoutChooserStore',
  listenables: [LayoutChooserActions],

  init() {
    this.block = null;
    this.theme = null;

    this.state = _.cloneDeep(initialState);
  },

  onUpdateBlock() {
    let block = _.get(this.state, "block");

    let data = {
      id: block.id,
      block: convertParallaxForMobile(block),
    };

    DocumentStore.dispatch({ type: COMMANDS.COPY_BLOCK_INTO_BLOCK, payload: data });

    LayoutChooserActions.closeDialog();
  },

  onUpdateSetting(prop, value) {
    _.set(this.state.settings, prop, value);

    this._updatePreview();

    this.trigger(this.state);
  },

  onOpenDialog(config) {
    this.init();

    this.theme = SiteDesignStore.getDesign().theme;
    this.state.preview.theme = this.theme;

    this.block = SiteDesignStore.getBlock(_.get(config, "id"));

    this._updatePreview();

    UIActions.modalOpen(AppConstants.MODAL_LAYOUT_CHOOSER);
  },

  onCloseDialog() {
    UIActions.modalClose(AppConstants.MODAL_LAYOUT_CHOOSER);

    this.init();
  },

  _updatePreview() {
    let blockObj = this.block.toJS();

    let transformer = new DesktopToMobileTransformer(blockObj, this.state.settings);

    blockObj = transformer.transform();

    this.state.block = blockObj;
    //needs to be in an array for preview
    this.state.preview.blocks = Immutable.fromJS([blockObj]);
  },

  getState() {
    return this.state;
  },
});

export default LayoutChooserStore;
